import styled from 'styled-components';
export var Title = styled.div.withConfig({
  displayName: "elements__Title",
  componentId: "oxg5ma-0"
})(["font-weight:600;font-size:", ";padding-bottom:", ";border-bottom:3px solid ", ";display:flex;align-items:center;"], function (_ref) {
  var isCompacted = _ref.isCompacted,
      fonts = _ref.theme.fonts;
  return isCompacted ? fonts.size.medium : fonts.size.big;
}, function (_ref2) {
  var isCompacted = _ref2.isCompacted;
  return isCompacted ? '1.2rem' : '1.5rem';
}, function (_ref3) {
  var palette = _ref3.theme.palette;
  return palette.primary["default"];
});